// extracted by mini-css-extract-plugin
export var dateLabel = "_4n-0";
export var dateLabelError = "_4n-1";
export var fullWidth = "_4n-2";
export var smaller = "_4n-3";